export const predefinedReviewTemplates = [
  {
    subject: 'Review - Very Disappointing Guest!',
    body: 'Unfortunately, our experience with this guest was very disappointing. They failed to follow several important house rules, communication throughout the stay was uncooperative, and the property was not left in an acceptable condition after checkout. These issues created unnecessary stress and additional work for us as hosts. Based on this experience, we would not recommend hosting this guest again, and we advise future hosts to be cautious when accepting a booking from them',
    rating: 1,
  },
  {
    subject: 'Review - Below Expectations!',
    body: 'Our experience with this guest was below expectations. While there were no major incidents, communication was inconsistent and some house rules were not respected during the stay. The property required extra cleaning after checkout, which caused inconvenience. With better communication and more care in following guidelines, this guest could have a smoother experience in the future. Unfortunately, based on this stay, we would not be eager to host them again',
    rating: 2,
  },
  {
    subject: 'Review - Average Guest!',
    body: 'The guest’s stay was average. Communication was generally okay, but there were some challenges that made the hosting experience less smooth than expected. A few house rules were overlooked, and the property required more cleaning than usual after checkout. While the stay was not problematic overall, there is room for improvement in attentiveness and communication. We would consider hosting this guest again if these areas are addressed.',
    rating: 3,
  },
  {
    subject: 'Review - Good Guest!',
    body: 'Overall, the guest was pleasant to host and communication during the stay was good. They respected most house rules and left the property in decent condition, though a little extra cleaning was needed after checkout. With a bit more attention to detail, this could have easily been a 5-star stay. We would be happy to host this guest again.',
    rating: 4,
  },
  {
    subject: 'Review - Excellent Guest!',
    body: '*|GUEST:NAME|* was an excellent guest! They were respectful of the house rules, left the space clean and tidy, and communicated promptly throughout their stay. It was a pleasure hosting them, and I would happily welcome them back anytime. Highly recommended to other hosts!',
    rating: 5,
  },
  {
    subject: 'Review - Outstanding Guest!',
    body: '*|GUEST:NAME|* was a fantastic guest! They treated the property with care, left everything spotless, and were easy to communicate with. Hosting them was a breeze, and I would gladly host them again in the future. Highly recommend!',
    rating: 5,
  },
  {
    subject: 'Review - Perfect Experience!',
    body: 'Hosting *|GUEST:NAME|* was a wonderful experience! They were courteous, followed all the house rules, and left the rental in excellent condition. Their clear and friendly communication made everything seamless. I would happily host them again and recommend them to any host.',
    rating: 5,
  },
]
